import * as Yup from "yup";

export const deactivatePatientValidationSchema = Yup.object().shape({
  reason: Yup.string()
    .trim()
    .required("Deactivate reason is required.")
    .max(100, "Deactivate reason can have maximum 100 characters."),
});
